import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import SakinPaneli from './SakinPaneli';

// URL parametresine göre panel seç
// ?panel=sakin  → Sakin Paneli
// diğer          → Admin Paneli
const params = new URLSearchParams(window.location.search);
const panelParam = params.get('panel');

const PanelRouter = () => {
  if (panelParam === 'sakin') {
    return <SakinPaneli />;
  }
  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PanelRouter />
  </React.StrictMode>
);
